exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProfileActivationModal .ProfileActivationModal_Body{font-family:inherit;font-weight:600;line-height:1.2em}.ProfileActivationModal .validationClassName{color:red}.ProfileActivationModal .ProfileActivationModalHeader{text-align:center}", ""]);

// exports
